import React from 'react'
import PropTypes from 'prop-types'
import { Chip, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import extract_user from '../functions/extract'

const styles = theme => ({
  root: {
    paddingTop: 8
  },
  successfullySaved: {
    transition: 'all 0.5s linear',
    opacity: 1,
     backgroundColor: theme.palette.secondary.purpleLight
   }

})

class AttachUsers extends React.Component {

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.open) {
      this.input.current.click()
      this.props.onClose()
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const tprops = this.props
    return (
      tprops.ccList.length !== nextProps.ccList.length ||
      tprops.alreadyAdded !== nextProps.alreadyAdded
    )
  }

  render () {
    const {ccList, classes, onDeleteCC, readOnly, alreadyAdded} = this.props

    return (
      <Grid container spacing={8} className={classes.root}>
        {ccList.map((user, i) => {
          let alreadyInList = user.to !== undefined?  (user.external? false : user.to.id === alreadyAdded[1] && user.group === alreadyAdded[0]): false
          return (
            <Grid item key={i}>
              <Chip className={alreadyInList ? classes.successfullySaved : ''}
                    key={user.to? user.to.id : user.id}
                    label={
                      user.external? user.ext_name :
                      user.group?
                      user.to === undefined?
                        user.name.full
                        : user.to.name.full
                      : user.to === undefined ?
                        user.email
                        : user.to.email === undefined ?
                          user.to.job_title
                          : extract_user(user.to.email)}
                onDelete={
                  readOnly
                    ? null
                    : e => {
                      user.to === undefined ? onDeleteCC(user.id) : onDeleteCC(user)
                    }
                }
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }
}

export default withStyles(styles)(AttachUsers)
AttachUsers.propTypes = {// open: PropTypes.bool.isRequired,
  ccList: PropTypes.array.isRequired,
  onDeleteCC: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/AttachUsers.js